// AI 노트 «단어 바꾸기»·«단어장» 호출 묶음(클로바 묶음 C3b).
// 🔴 axios 래퍼(api/client.js)를 쓰지 않는다 — 상세 화면의 다른 호출(요약 버전·참석자 저장)이
//    모두 fetch 라 시험이 `global.fetch` 하나만 목으로 둔다.
// 🔴 JSON 본문에는 `Content-Type: application/json` 을 반드시 붙인다. 빼면 브라우저가
//    text/plain 으로 보내고 FastAPI 가 422 를 낸다(참석자 저장에서 실측한 함정).

const apiBase = () => process.env.REACT_APP_API_URL || '';

const authHeader = () => {
  try {
    const token = localStorage.getItem('token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch (e) {
    return {};   // 저장소 접근 불가(사생활 모드 등) — 서버가 401 로 답한다
  }
};

export async function jsonFetch(path, { method = 'GET', body } = {}) {
  const res = await fetch(`${apiBase()}${path}`, {
    method,
    headers: { 'Content-Type': 'application/json', ...authHeader() },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  return { ok: res.ok, status: res.status, data };
}

// 🔴 422 의 detail 은 배열(FastAPI 검증 오류)이라 **문자열일 때만** 그대로 보인다.
export function detailOr(data, fallback) {
  const detail = data && data.detail;
  return typeof detail === 'string' && detail.trim() ? detail : fallback;
}

export const replaceWords = (meetingId, payload) =>
  jsonFetch(`/api/meetings/${meetingId}/replace`, { method: 'POST', body: payload });

export const getGlossary = () => jsonFetch('/api/meetings/glossary');

export const putGlossary = (terms) =>
  jsonFetch('/api/meetings/glossary', { method: 'PUT', body: { terms } });

export const addGlossaryTerm = (term) =>
  jsonFetch('/api/meetings/glossary/terms', { method: 'POST', body: { term } });
